// src/dashboard/Dashboard.jsx
import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { AuthContext } from '../auth/AuthContext';
import { StatsContext } from '../stats/StatsContext';
import DashboardStats from '../stats/DashboardStats';

const getTimeOfDay = () => {
  const hour = new Date().getHours();
  if (hour < 12) return 'Morning';
  if (hour < 18) return 'Afternoon';
  return 'Evening';
};

const Dashboard = () => {
  const { currentUser } = useContext(AuthContext);
  const { stats, fetchStats } = useContext(StatsContext);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    if (!currentUser) {
      navigate('/login');
    } else {
      fetchStats();
    }
  }, [currentUser, navigate, fetchStats]);

  return (
  <Box
    sx={{
      position: "relative",
      overflow: "hidden",
      py: { xs: 3, md: 5 },
    }}
  >
    {/* Decorative Background */}
    <Box
      sx={{
        position: "absolute",
        top: -120,
        left: -120,
        width: 280,
        height: 280,
        borderRadius: "50%",
        background: "rgba(0,230,118,0.18)",
        filter: "blur(80px)",
      }}
    />

    <Box
      sx={{
        position: "absolute",
        bottom: -120,
        right: -100,
        width: 320,
        height: 320,
        borderRadius: "50%",
        background: "rgba(178,255,89,0.15)",
        filter: "blur(90px)",
      }}
    />

    {/* Hero */}
    <Box
      sx={{
        position: "relative",
        zIndex: 2,
        maxWidth: 1000,
        mx: "auto",
        mb: 5,

        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",

        py: { xs: 5, md: 7 },
        px: { xs: 3, md: 6 },

        borderRadius: "30px",

        background:
          "linear-gradient(135deg, rgba(255,255,255,.18), rgba(255,255,255,.08))",

        backdropFilter: "blur(18px)",
        WebkitBackdropFilter: "blur(18px)",

        border: "1px solid rgba(255,255,255,.2)",

        boxShadow:
          "0 20px 60px rgba(0,0,0,.25), inset 0 1px 0 rgba(255,255,255,.15)",
      }}
    >
      <Typography
        sx={{
          fontSize: { xs: "2.3rem", md: "3.8rem" },
          fontWeight: 900,
          lineHeight: 1.1,

          background:
            "linear-gradient(90deg,#00E676,#69F0AE,#C6FF00)",

          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",

          mb: 2,
        }}
      >
        Good {getTimeOfDay()}, {currentUser?.name}! 👋
      </Typography>

      <Typography
        sx={{
          color: "rgba(255,255,255,.96)",
          fontSize: { xs: "1.1rem", md: "1.3rem" },
          maxWidth: 720,
          lineHeight: 1.8,
          mb: 4,
        }}
      >
        Welcome back to <b>MazGuard</b>. Monitor environmental reports,
        collaborate with your community, and make a measurable impact on the
        environment through real-time insights.
      </Typography>

      {/* Quick summary */}
      {/* <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: 2,
        }}
      >
        {[
          "🌍 Environmental Reports",
          "📍 Live Issue Tracking",
          "👥 Community Engagement",
          "📊 Real-time Analytics",
        ].map((item) => (
          <Box
            key={item}
            sx={{
              px: 2.5,
              py: 1.2,
              borderRadius: 50,
              bgcolor: "rgba(255,255,255,.12)",
              border: "1px solid rgba(255,255,255,.15)",
              color: "#fff",
              fontWeight: 600,
              backdropFilter: "blur(10px)",
            }}
          >
            {item}
          </Box>
        ))}
      </Box> */}
    </Box>

    {/* Statistics */}
    <Box
      sx={{
        position: "relative",
        zIndex: 2,
        mt: 2,
      }}
    >
      <DashboardStats stats={stats} />
    </Box>
  </Box>
);
};

export default Dashboard;